// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProfileAdminTools":"iz_a bih_vu bih_ql bih_va bih_gy bih_kg bih_sv","ProfileAdminTools__item":"iz_b"};